import { useRef } from "react";
import { Link } from "react-router-dom";
import { featuredArticles } from "@/mocks/articles";

export default function ArticleSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const amount = 340;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs font-medium text-foreground-500 uppercase tracking-widest mb-3">
              Latest Articles
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Hipobuy Sheet{" "}
              <span className="text-accent-500">Guides</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <span className="px-3 py-1 text-xs font-medium text-background-50 bg-foreground-950 rounded-full whitespace-nowrap">
              New
            </span>
            <div className="flex items-center gap-2">
              <button
                onClick={() => scroll("left")}
                className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-600 hover:bg-foreground-100 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button
                onClick={() => scroll("right")}
                className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-600 hover:bg-foreground-100 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
            </div>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 md:gap-5 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="flex-shrink-0 w-72 md:w-80 snap-start group cursor-pointer"
            >
              <div className="bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200/70 transition-colors">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs text-foreground-400">{article.date}</span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <span className="text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    Read &rarr;
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}